import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LifeInsuranceFormFields } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/LifeInsuranceFormFields";
import { useEditLifeInsuranceForm } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/useEditLifeInsuranceForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditLifeInsuranceFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditLifeInsuranceForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditLifeInsuranceFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } =
		useEditLifeInsuranceForm({
			portfolioId,
			portfolio,
			detailRoute,
		});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<LifeInsuranceFormFields
				control={form.control}
				productCategory={portfolio.productCategory}
			/>
		</PortfolioFormShell>
	);
};
